export default __webpack_public_path__ + "static/media/hht2_ep19_speaking_02.3f0e7253.png";